import { Category } from "../../api/category";
import { getCategoryCheckLines } from "../../utils/categoryFormat";
import { PricelistTableCellLines } from "../PricelistTable/PricelistTableCells";
import "../RequestTable/RequestTable.scss";

interface CategoryTableProps {
  data: Category[];
  onRowClick: (id: string) => void;
}

export const CategoryTable = ({ data, onRowClick }: CategoryTableProps) => (
  <div className="request-table-wrapper">
    <div className="request-table-card">
      <table className="request-table request-table--pricelist">
        <thead>
          <tr>
            <th>Название</th>
            <th>Описание</th>
            <th>Проверки</th>
          </tr>
        </thead>
        <tbody>
          {data.length === 0 ? (
            <tr>
              <td colSpan={3} className="request-table-empty">
                Нет данных
              </td>
            </tr>
          ) : (
            data.map((item) => (
              <tr
                key={item.id}
                className="request-table-row-clickable"
                onClick={() => item.id && onRowClick(item.id)}
              >
                <td>{item.name?.trim() || "—"}</td>
                <td>{item.description?.trim() || "—"}</td>
                <td>
                  <PricelistTableCellLines lines={getCategoryCheckLines(item)} />
                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  </div>
);
